import React from "react";
import FiberPlanSelector from "./../../../components/FiberPlanSelector";
import Swal from "sweetalert2";
import OfferApi from "../../../API/OfferApi";
import { MdDelete } from "react-icons/md";
import StringIntReq from "../../../Requests/StringIntReq";
import { Navigation, A11y, EffectCoverflow, Pagination } from "swiper/modules";
import { useState } from "react";
import { useEffect } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
// import "./ReviewComponent.scss";
import "swiper/css";
import "swiper/css/navigation";
import SearchOfferTemplatesReq from "../../../Requests/OfferTemplate/SearchOfferTemplatesReq";
const AddFiberPlanToOfferTemplate = ({ company, offerTemplate, setReload,reload }) => {
  const [fiberPlan, setFiberPlan] = useState(null);
  const [discount, setDiscount] = useState(0);
  const [promotionalName, setPromotionalName] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [offers, setOffers] = useState([]);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [bulletPoints, setBulletPoints] = useState("");
  const [promos, setPromos] = useState("");
  const [planes, setPlanes] = useState([]);
  const [indicator, setIndicator] = useState(false);
  

//   console.log("ffer template: ", offerTemplate);
  const addFiberPlan = async () => {
    Swal.fire({
      title: "Adding Fiber Plan",
      icon: "info",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      customClass: {
        container: "custom-swal",
      },
      didOpen: () => {
        Swal.showLoading();
      },
    });

    if (!fiberPlan) {
      Swal.fire({
        icon: "error",
        title: "Fiber Plan is required",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    if (isNaN(discount)) {
      Swal.fire({
        icon: "error",
        title: "Discount must be a number",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      return;
    }

    const offerTemplateFiberPlan = {
      fiberPlanId: fiberPlan.id,
      discount: discount,
      offerTemplateId: id,
      promotionalName: promotionalName,
    };

    const res = await OfferApi.CreateOfferTemplateFiberPlan(
      offerTemplateFiberPlan
    );
    if (res?.status?.success) {
        setIndicator(!indicator);
      Swal.fire({
        icon: "success",
        title: "Fiber Plan Added Successfully",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      setReload((prev) => !prev);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to add Fiber Plan",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const removeFiberPlan = async (offerTemplatePlanId) => {
    const selected = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (!selected.isConfirmed) {
      return;
    }

    Swal.fire({
      title: "Removing Fiber Plan",
      icon: "info",
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      customClass: {
        container: "custom-swal",
      },
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const req = new StringIntReq();
    req.int = offerTemplatePlanId;

    const res = await OfferApi.DeleteOfferTemplateFiberPlan(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Fiber Plan Removed Successfully",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      setReload((prev) => !prev);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to remove Fiber Plan",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  useEffect(() => {
    if (company) searchOfferTemplate();
  }, [company,indicator]);

  const searchOfferTemplate = async () => {
    const req = new SearchOfferTemplatesReq();
    req.fiberCompanyId = company.id;
    const res = await OfferApi.SearchOfferTemplate(req);

    if (res?.status?.success) {
      setOffers(res?.data);
      setName(res?.data[0]?.name);
      setDiscount(res?.data[0]?.discount);
      setBulletPoints(res?.data[0]?.bulletPoints);
      setPromos(res?.data[0]?.promos);
      setId(res?.data[0]?.id);
      setPlanes(res?.data[0]?.offerTemplateFiberPlans);
    } else {
      Swal.fire({
        icon: "error",
        title: "Failed to fetch Offer Template",
        customClass: {
          container: "custom-swal",
        },
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };
  
//   console.log("offers: ", offers);

  return (
    <div className="add_plan_to_template overflow-hidden">
      {/* <h1>Add Fiber Plan to Offer Template</h1> */}
      <div className=" max-x[100vw] overflow-hidden ">
        <Swiper
          modules={[Navigation, A11y, EffectCoverflow, Pagination]}
          spaceBetween={5}
          slidesPerView={3} // Dynamically adjust slidesPerView
          navigation={true}
          // pagination={{
          //   clickable: true,
          // }}
          scrollbar={{ draggable: true }}
          onSwiper={(swiper) => console.log(swiper)}
          onSlideChange={(swiper) => {
            if (swiper.isEnd) {
              setPageNumber(pageNumber + 1);
            }
          }}
        >
          <div className="flex items-center ">
            {offers.map((offer) => {
              return (
                <SwiperSlide key={offer.id}>
                  <div
                    onClick={() => {
                    //   setIsAdd(false);
                      setName(offer.name);
                      setDiscount(offer.discount);
                      setBulletPoints(offer.bulletPoints);
                      setPromos(offer.promos);
                      setId(offer.id);
                      setPlanes(offer.offerTemplateFiberPlans);
                    }}
                    className={`flex p-4 border  rounded-md justify-center items-center cursor-pointer ${
                      offer.id === id ? " border-blue-400" : "border-gray-300"
                    }`}
                  >
                    <p>{offer.name}</p>
                  </div>
                </SwiperSlide>
              );
            })}
          </div>

         
        </Swiper>
      </div>
      {offerTemplate ? (
        <>
          <div className="form">
            <h2>Offer Template Fiber Plans</h2>
            <FiberPlanSelector
              placeholder="Slect Fiber Plan"
              setUser={setFiberPlan}
              fiberCompany={company?.id}
            />
            {fiberPlan && (
              <>
                <input
                  type="number"
                  placeholder="Discount"
                  value={discount}
                  onChange={(e) => setDiscount(e.target.value)}
                />
                <input
                  type="text"
                  placeholder="Promotional Name"
                  value={promotionalName}
                  onChange={(e) => setPromotionalName(e.target.value)}
                />
                <button
                  onClick={() => {
                    addFiberPlan();
                  }}
                >
                  Add
                </button>
              </>
            )}
          </div>
          <div className="fiber_plans">
          
            {
              planes.map((item, index) => {
                return (
                  <div key={index} className="fiber_plan">
                    <h3>{item?.fiberPlan?.name}</h3>
                    <div>
                      <p>Discount: ${item?.discount}</p>
                      <p>Price: ${item?.fiberPlan?.price}</p>
                      <p>Speed: {item?.fiberPlan?.speed * 1000} Mbps</p>
                    </div>
                    <button
                      onClick={() => {
                        removeFiberPlan(item.id);
                      }}
                    >
                      <MdDelete color="white" size={30} />
                    </button>
                  </div>
                );
              })
            }
          </div>
        </>
      ) : (
        <h1>Create an Offer Template First</h1>
      )}
    </div>
  );
};

export default AddFiberPlanToOfferTemplate;
